var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "con-exemple-prompt", attrs: { id: "resourceForm" } },
    [
      _c(
        "vs-row",
        [
          _c("vs-col", { attrs: { "vs-w": "12" } }, [
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                _c("span", [_vm._v("Libellé* :")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col sm:w-2/3 w-full" },
                [
                  _c("vs-input", {
                    staticClass: "w-full",
                    attrs: { name: "title", required: "" },
                    model: {
                      value: _vm.resource.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.resource, "title", $$v)
                      },
                      expression: "resource.title",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                _c("span", [_vm._v("Type* :")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col sm:w-2/3 w-full" },
                [
                  _vm.type != "show"
                    ? [
                        _c(
                          "div",
                          {
                            ref: "tooltip",
                            staticStyle: { "min-height": "43px" },
                            attrs: {
                              "data-toggle": "tooltip",
                              "data-placement": "top",
                              title:
                                "Cette donnée permet de catégoriser vos grilles (Exemple : ROME, RSFP, …) . Vous pouvez sélectionner une valeur existante ou en ajouter une nouvelle.",
                            },
                          },
                          [
                            _c("TypeForm", {
                              attrs: { availableTypes: _vm.types.data },
                              model: {
                                value: _vm.resource.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.resource, "type", $$v)
                                },
                                expression: "resource.type",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _c("span", [_vm._v(_vm._s(_vm.resource.type))]),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                _c("span", [_vm._v("Filière* :")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col sm:w-2/3 w-full" },
                [
                  _vm.type != "show"
                    ? [
                        _c("Multiselect", {
                          attrs: {
                            name: "addServiceSector",
                            options: _vm.sectors.data,
                            "track-by": "id",
                            label: "title",
                            multiple: false,
                            "group-select": false,
                            placeholder: "Recherche ...",
                            "select-label": "",
                            "select-group-label": "",
                            "selected-label": "",
                            "deselect-label": "",
                            "deselect-group-label": "",
                            loading: _vm.sectors.loading,
                          },
                          model: {
                            value: _vm.resource.sector,
                            callback: function ($$v) {
                              _vm.$set(_vm.resource, "sector", $$v)
                            },
                            expression: "resource.sector",
                          },
                        }),
                      ]
                    : _c("span", [_vm._v(_vm._s(_vm.resource.sector.title))]),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                _c("span", [_vm._v("Description :")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col sm:w-2/3 w-full" },
                [
                  _vm.type != "show"
                    ? _c("vs-textarea", {
                        attrs: { name: "description" },
                        model: {
                          value: _vm.resource.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.resource, "description", $$v)
                          },
                          expression: "resource.description",
                        },
                      })
                    : _c("span", [_vm._v(_vm._s(_vm.resource.description))]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c(
                "div",
                { staticClass: "vx-col w-full" },
                [
                  _c("OccupationSkillsSelector", {
                    attrs: {
                      displayAll: _vm.allOccSkills,
                      gridSector: _vm.resource.sector,
                    },
                    model: {
                      value: _vm.resource.occupation_skills,
                      callback: function ($$v) {
                        _vm.$set(_vm.resource, "occupation_skills", $$v)
                      },
                      expression: "resource.occupation_skills",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }